var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card h-100 testimonial-item-1",class:[_vm.cols('', 'mb-4'), _vm.theme],style:({..._vm.border, ..._vm.shadow, ..._vm.backgroundColor, padding: _vm.padding})},[_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }